import { StageV2 } from 'modules/championship/domain/interfaces/stage';
import { UpsertChampionshipStageParams } from 'modules/championship/domain/repositories/stage.repository';
import { upsertStage } from 'modules/championship/store/stages/stages.actions';
import { useLingui } from '@lingui/react/macro';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'store/hooks';

/** Сохраняет этап и предупреждает, если backend не стал пересоздавать сетку плей-офф.
 *
 * Этап в этом случае сохранён — сообщение живёт здесь, а не в репозитории или reducer'е,
 * и все три экрана, сохраняющие этап, показывают его одинаково.
 *
 * Возвращает `undefined`, если сохранить не удалось. */
export function useUpsertStage() {
  const dispatch = useAppDispatch();
  const { t } = useLingui();

  return useCallback(
    async (params: UpsertChampionshipStageParams): Promise<StageV2 | undefined> => {
      const result = await dispatch(upsertStage(params))
        .unwrap()
        .catch(() => undefined);

      if (!result) return undefined;

      if (result.bracketsUpdateSkipped) {
        toast.error(t`Нельзя обновить тип этапа, так как матч начинается менее чем через 5 часов. Сетка матчей не будет обновлена.`);
      }

      return result.stage;
    },
    [dispatch, t],
  );
}

export default useUpsertStage;
